import { Box } from '@mui/material';

import { TourTravel } from '@/domain/project-tour-ontour/entities/project-tour-ontour-travel.entity';

import { TourTraveListIncoming } from './TourTraveListIncoming';

export function TourTraveListIncomingEmpty() {
  const fakeTourTravel = buildFakeTourTravel();
  return (
    <Box visibility={'hidden'}>
      <TourTraveListIncoming
        tourTravels={[fakeTourTravel]}
        onClickDelete={() => {}}
        onClickAdd={() => {}}
        favoriteIds={new Set()}
        onToggleFavorite={() => {}}
        favoriteTravels={[]}
        onCopyTravel={() => {}}
        isWindowFavorite={false}
        onToggleWindowFavorite={() => {}}
        favoriteGroups={[]}
        onCopyGroup={() => {}}
      />
    </Box>
  );
}

function buildFakeTourTravel(): TourTravel {
  return {
    id: 0,
    sequenceId: 0,
    name: '',
    connexionTypeWithEvent: 'incoming',
    travelDistance: 0,
    fromEventId: undefined,
    fromPosition: undefined,
    toEventId: undefined,
    toPosition: undefined,
  };
}
